import type { App } from 'vue'
import AppCard from './app-card.vue'

export const useCard = {
  install (app: App) {
    app.component('AppCard', AppCard)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    AppCard: typeof AppCard,
  }
}
